import { useGetUserContextQuery } from '@project/store/services/userContextApi';
import React, { createContext, useState, ReactNode, useContext, useEffect } from 'react';

// Define the type for the context value
interface NavigationContextType {
  cartCount: number;
  setCartCount: React.Dispatch<React.SetStateAction<number>>;
}

// Create the context with an empty default value
export const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

// Context provider component props
interface NavigationProviderProps {
  children: ReactNode;
}

// Context provider component
export const NavigationProvider = ({ children }: NavigationProviderProps) => {
  const { data: userData } = useGetUserContextQuery('');
  const [cartCount, setCartCount] = useState<number>(0);

  useEffect(() => {
    if (userData) {
      setCartCount((userData as any)?.user_resource_cart?.length);
    }
  }, [userData]);

  return <NavigationContext.Provider value={{ cartCount, setCartCount }}>{children}</NavigationContext.Provider>;
};

// Custom hook to use the NavigationContext (optional)
export const useNavigationContext = (): NavigationContextType => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigationContext must be used within a NavigationProvider');
  }
  return context;
};
